import { connect } from 'react-redux';
import modal from 'decorators/Modal/Modal';
import { hideModal } from 'redux/modules/modals';
import { ReactivationModal as ReactivationModalUnwrapped } from 'features/Reactivation/ReactivationModal';
export var modalConfig = {
  lightClose: true
};
export var mapStateToProps = function mapStateToProps() {
  return {};
};
export var mapDispatchToProps = {
  onCtaClick: hideModal
};
export var ReactivationModalContainer = connect(mapStateToProps, mapDispatchToProps)(modal(modalConfig)(ReactivationModalUnwrapped));